import { FormikProps } from "formik";
import { FormValues } from "./AdvanceType";

 export const DateRangeRow: React.FC<{ label: string; namePrefix: string; formik: FormikProps<FormValues> }> = ({
  label,
  namePrefix,
  formik,
}) => {
  const format = (d: Date) => d.toISOString().split("T")[0];
  const handleQuickSelect = (days: number) => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - days);
    formik.setFieldValue(`${namePrefix}From`, format(past));
    formik.setFieldValue(`${namePrefix}To`, format(today));
  };

  return (
    <div className="date-row">
      <div className="row">
        <label className="label">{label}</label>
        <div className="date-container">
          <div >
            <input type="date" {...formik.getFieldProps(`${namePrefix}From`)} className="inputdate" />
            {/* <FiCalendar className="icon" /> */}
          </div>
          <span className="separator">to</span>
          <div className="date-input-wrapper">
            <input type="date" {...formik.getFieldProps(`${namePrefix}To`)} className="inputdate" />
            {/* <FiCalendar className="icon" /> */}
          </div>
        </div>
      </div>
      <div className="quick-link-bar">
        <button type="button" onClick={() => handleQuickSelect(7)} className="quick-link">Last 7 days</button>
        <span className="separator">|</span>
        <button type="button" onClick={() => handleQuickSelect(30)} className="quick-link">Last 30 days</button>
      </div>
    </div>
  );
};
